const tracking = require('../../modules/utils/tracking.utils');
const USE_ONLY_VALUE_PREFIX = '_';
const CODE_REGEXP = new RegExp(/%([A-Z])/g);
const buildCodeFromParams = (code, map, params) => {
    return code.replace(CODE_REGEXP, buildCodeFromParamsCallback.bind(null, map, params));
};

const PROVIDER_TYPE = {
    '1A': 'GDS',
    'TP': 'GDS',
    'TF': 'TF',
    'VY': 'VLG',
    'NA': 'NA',
    'XFARE': 'XFARE',
};

const CTA = {
    click: 'click',
    change: 'change',
    back: 'back',
    confirm: 'confirm',
};

const buildCodeFromParamsCallback = (placeHoldersMap, params, match, mapKey) => {
    const paramConfig = placeHoldersMap[mapKey];
    const paramName = getParamName(paramConfig);
    const replaceWithJustParamValue = paramName[0] === USE_ONLY_VALUE_PREFIX;
    const paramValue = getParamValue(paramConfig, params, paramName, replaceWithJustParamValue);

    const replaceWithParamNameAndValue = !replaceWithJustParamValue && paramValue !== undefined;
    return replaceWithJustParamValue
        ? paramValue
        : paramName + (replaceWithParamNameAndValue ? `:${paramValue}` : '');
};

const getParamName = (paramConfig) => {
    return typeof paramConfig === 'object'
        ? paramConfig.name
        : paramConfig;
};

const getParamValue = (paramConfig, params, paramName, replaceWithJustParamValue) => {
    const key = replaceWithJustParamValue ? paramName.substring(1) : paramName;
    return typeof paramConfig === 'object'
        ? buildCodeFromParams(paramConfig.code, paramConfig.map, Odigeo._.get(params, key, {}))
        : Odigeo._.get(params, key);
};

class AncillariesTracking {
    constructor(dictionary, ACTION_KEY) {
        this.action = dictionary.action;
        this.label = dictionary.label;
        this.actionKey = ACTION_KEY;
    }

    trackEvent(eventData = {}) {
        const action = this.buildEventString('action', eventData);
        const label = this.buildEventString('label', eventData);

        if (label || action) {
            tracking.trackEvent(action, label);
        }
    }

    trackEventWithCategory(eventData = {}, category) {
        const action = this.buildEventString('action', eventData);
        const label = this.buildEventString('label', eventData);

        if (label || action) {
            tracking.trackEventWithCategory(category, action, label);
        }
    }

    buildEventString(type, eventData) {
        const data = eventData[type];
        let eventString;
        if (data !== undefined) {
            const {name, params} = data;
            const dictionaryEntry = this[type][name] || {};
            const {code, map} = dictionaryEntry;

            if (code !== undefined && map !== undefined) {
                eventString = buildCodeFromParams(code, map, params);
            } else if (typeof dictionaryEntry === 'string') {
                eventString = dictionaryEntry;
            }
        }

        return eventString;
    }

    onLoad(params) {
        this.trackEvent({
            action: {
                name: 'on_load_widgets',
            },
            label: {
                name: 'loaded',
                params,
            },
        });
    }

    reviewSelection(params, cta) {
        if (cta) {
            params.click = cta;
        }

        this.trackEvent({
            action: {
                name: 'selection',
                params: {
                    name: this.actionKey,
                },
            },
            label: {
                name: 'review_selection',
                params,
            },
        });
    }

    onOpen(params) {
        return this.reviewSelection(params);
    }

    onClose(params) {
        return this.reviewSelection(params, CTA.back);
    }

    onConfirm(params) {
        return this.reviewSelection(params, CTA.confirm);
    }
}

AncillariesTracking.SCENARIOS = {
    none: '0',
    some: 'some',
    all: 'all',
};

AncillariesTracking.getSelectedItineraryProvider = () => {
    const flightData = JSON.parse(Odigeo.Session.get('flightSelectionData'));
    const fareItineraryKey = Odigeo._.get(flightData, 'data.fareItineraryKey', '');
    const providerInfo = fareItineraryKey.split(',').splice(1);
    let provider = PROVIDER_TYPE.NA;
    if (providerInfo.length) {
        provider = PROVIDER_TYPE.XFARE;
        if (providerInfo.length === 1) {
            const providerCode = providerInfo[0].replace(/_.*$/, '');
            provider = PROVIDER_TYPE[providerCode] || PROVIDER_TYPE.NA;
        }
    }

    return provider;
};

AncillariesTracking.getProviderFromBookingInfo = (bookingInfo = {}) => {
    const segments = Odigeo._.get(bookingInfo, 'itineraryBookings.itinerarySegments', []);
    const providersMaps = segments.reduce((acc, segment) => {
        const sections = segment.sections || [];
        return sections.reduce((sectionsAcc, section) => Object.assign(acc, {[section.provider]: true}), acc);
    }, {});

    const providers = Object.keys(providersMaps);
    switch (providers.length) {
        case 0:
            return PROVIDER_TYPE.NA;
        case 1:
            return PROVIDER_TYPE[providers[0]] || PROVIDER_TYPE.NA;
        default:
            return PROVIDER_TYPE.XFARE;
    }
};

module.exports = AncillariesTracking;
